// Arbitrary order in which we seek to sort
const DAY_ORDER: { [dayLabel: string]: number } = {
  Undetermined: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7,
};

export default (day1: string, day2: string) => {
  const day1int = DAY_ORDER[day1];
  const day2int = DAY_ORDER[day2];

  if (day1int === day2int) return 0;
  if (day1int > day2int) return 1;
  return -1;
};
